import url_ from "asset-data:assets/galleries/featured/boribap_944c7a30e2__1600.jpg";
export const url = url_;